import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=b8b2104a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b2104a')) {
      api.createRecord('b8b2104a', component.options)
    } else {
      api.reload('b8b2104a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=b8b2104a&", function () {
      api.rerender('b8b2104a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221WAjsK73v1i/JS/comp/ImgFallback.vue"
export default component.exports